import React from 'react';
import styled from 'styled-components';

import AnalysisGate from './ContentTab/AnalysisGate';
import SuggestionList from './ContentTab/SuggestionList';

// Reports nobody has made AI-ready yet, ranked by how much they'd add. The
// analysis gate loads every definition + metric, so this is mounted on its own
// route rather than around the whole screen.

const Pane = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const UnflaggedPanel = () => (
  <Pane data-testid="agent-kb-unflagged">
    <AnalysisGate>
      <SuggestionList />
    </AnalysisGate>
  </Pane>
);

export default UnflaggedPanel;
